export abstract class AbstractCycleDateService {
  abstract getCurrentCycleDate(): Promise<string | undefined>;
}
